import React from 'react';
import { Map as LeafletMap, TileLayer } from 'react-leaflet';
import { CollapsibleTableContainer } from './CollapsibleTableContainer';
import * as Constants from './constants';

export const BpmMap = ({
    mapContent,
    dataTable
}) => {
    return (
        <div>
            <div style={{ border: "1px solid darkgray" }}>
                <LeafletMap
                    center={Constants.DEFAULT_MAP_LOCATION}
                    zoom={Constants.DEFAULT_MAP_ZOOM_LEVEL}
                    maxZoom={Constants.MAP_MAX_ZOOM}
                >
                    <TileLayer
                        attribution={Constants.MAP_ATTRIBUTION}
                        url={Constants.MAP_TILES_URL}
                    />
                    {mapContent}
                </LeafletMap>
            </div>
            <CollapsibleTableContainer>
                {dataTable}
            </CollapsibleTableContainer>
        </div>
    );
}
